<template>
  <div class="d-grid mb-3">
    <div class="btn btn-danger"
:class="filterApplied ? '' : 'disabled'"
         @click="resetFilter">Resetovat filtr</div>
  </div>
  <div class="row" id="offer-filter"
       @change="changeFiler">
    <div class="mb-3">
      <h6>Seřadit</h6>
      <select name="offer-filter_order" class="form-select mb-2"
              @change="changeOrder"
              v-model="order">
        <option value="none">Výchozí</option>
        <option value="az">&darr; A-Z</option>
        <option value="za">&uarr; Z-A</option>
        <option value="yield-desc">&darr; Úrok od nejvyšší</option>
        <option value="yield-asc">&uarr; Úrok od nejnižší</option>
        <option value="deposit-desc">&darr; Minimální investice od nejvyšší</option>
        <option value="deposit-asc">&uarr; Minimální investice od nejnižší</option>
      </select>
    </div>
    <div class="mb-3">
      <h6>Hledat</h6>
      <input type="text" id="search" class="form-control"
             v-model="search"
             placeholder="Hledaný text..."
             @keyup="searchTimeOut()">
    </div>
    <div class="mb-3">
      <h6>Investice od</h6>
      <div class="input-group mb-3">
        <input type="text" class="form-control" style="max-width: 10ch"
               :value="filterAmount(amountValueMin)"
               @input="updateVariable($event.target.value, 'amountValueMin')"
               @keyup="changeFiler"/>
        <span class="input-group-text">-</span>
        <input type="text" class="form-control"
               :value="filterAmount(amountValueMax)"
               @input="updateVariable($event.target.value, 'amountValueMax')"
               @keyup="changeFiler"/>
      </div>

      <vue-slider v-model="amountValues"
                  :min="amount.limits[0]"
                  :max="amount.limits[1]"
                  :interval="500"
                  :tooltip-formatter="filterAmount(amountValues)"
                  @dragEnd="changeFiler"/>
    </div>
    <div class="mb-3">
      <h6>Výnos</h6>
      <div class="input-group mb-3">
        <input type="text" class="form-control"
               :value="filterYield(yieldValueMin)"
               @input="updateVariable($event.target.value, 'yieldValueMin')"
               @keyup="changeFiler"
        />
        <span class="input-group-text">-</span>
        <input type="text" class="form-control"
               :value="filterYield(yieldValueMax)"
               @input="updateVariable($event.target.value, 'yieldValueMax')"
               @keyup="changeFiler"
        />
      </div>

      <vue-slider v-model="yieldValues"
                  :min="yield.limits[0]"
                  :max="yield.limits[1]"
                  :interval="0.1"
                  :tooltip-formatter="filterYield(yieldValues)"
                  @dragEnd="changeFiler"
      />

    </div>
    <div class="mb-5">
      <h6>Splatnost za</h6>
      <vue-slider class="calc-slider-wrapper"
                  v-model="timeHorizon.values"
                  :adsorb="true"
                  :min="0"
                  :max="5"
                  :marks="{0: '>1 rok', 1: '1rok', 2: '2 roky',3:'3 roky',4:'4 roky',5:'5 let<'}"
                  @dragEnd="changeFiler">
      </vue-slider>
      <!--<div class="form-check form-check-inline"
           v-for="(n, idx) in timeHorizon.limits"
      >
        <input class="form-check-input" type="checkbox"
               :id="'timeHorizon_' + idx"
               v-model="timeHorizon.values"
               :value="n"
               @mouseover=""
               @change=""
        >
        <label :for="'timeHorizon_' + idx" class="form-check-label">
          {{ n }}
        </label>
      </div>-->

    </div>
    <div class="mb-3">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch"
               id="earlyPaymentPossible" v-model="earlyRepaymentPossible">
        <label class="form-check-label" for="earlyPaymentPossible">
          Možnost předčasného splacení
          <span class="icon_info" data-bs-toggle='tooltip'
                data-bs-title="Emitent umožňuje požádat o předčaného splacení na základě Vašeho požadavku."></span>

        </label>
      </div>
    </div>
    <div class="mb-3">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch"
               id="isApprovedByCNB" v-model="isApprovedByCnb">
        <label class="form-check-label" for="isApprovedByCNB">
          Prospekt schválený ČNB
          <span class="icon_info" data-bs-toggle='tooltip'
                data-bs-title="
Česká národní banka pouze osvědčuje, že schválený prospekt splňuje normy týkající se úplnosti, srozumitelnosti a soudržnosti požadované Nařízením o prospektu a dalšími příslušnými právními předpisy, tedy že obsahuje nezbytné informace, které jsou podstatné pro to, aby investor informovaně posoudil emitenta a cenné papíry.
ČNB neposuzuje hospodářské výsledky ani finanční situaci emitenta a schválením prospektu negarantuje budoucí ziskovost emitenta ani jeho schopnost splatit úroky nebo jmenovitou hodnotu cenného papíru.
">
                                            </span>
        </label>
      </div>
    </div>
    <div class="mb-3">
      <h6>Výplata výnosů</h6>
      <div class="form-check"
           v-for="(n, idx) in paymentPeriod.limits"
      >
        <input class="form-check-input" type="checkbox"
               :id="'paymentPeriod_' + idx"
               v-model="paymentPeriod.values"
               :value="n"
               @mouseover=""
               @change=""
        >
        <label :for="'paymentPeriod_' + idx" class="form-check-label">
          {{ filterPaymentPeriod(n) }}
        </label>
      </div>

    </div>
    <div class="mb-3">
      <div id="offer-filter_categories">
        <h6>Zajištění</h6>
        <div @mouseleave="handleCheckboxMouseleave(6)">
          <div class="form-check"
               v-for="(n,idx) in 6"
          >
            <input class="form-check-input" type="checkbox"
                   :id="'collaterals_' + idx"
                   v-model="collateralsChecked"
                   :value="idx"
                   @mouseover="handleCheckboxMouseover(idx,6)"
                   @change="handleCheckboxChange(idx)"
            >
            <label :for="'collaterals_' + idx" class="form-check-label">
              {{ idx }}+
            </label>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: "OfferFilter",
  components: {
    VueSlider,
  },
  data: () => ({
    amountValueMin: Number,
    amountValueMax: Number,
    amount: {
      limits: [0, 1000000],
    },
    yieldValueMin: Number,
    yieldValueMax: Number,
    yield: {
      limits: [],
    },
    paymentPeriod: {
      values: [],
      limits: [],
    },
    timeHorizon: {
      values: [0, 5],
      limits: [0, 5],
    },
    search: null,
    collaterals: false,
    collateralsChecked: [],
    earlyRepaymentPossible: false,
    isApprovedByCnb: false,
    order: 'none',
    filterApplied : false,
  }),
  props: {},
  mounted: function () {
    const activeOffers = document.getElementById('offers-active');
    const self = this;
    const amounts = [];
    const yields = [];
    let timeHorizon = [];
    let paymentPeriod = [];
    Array.from(activeOffers.children).forEach(function (item) {
      let params = item.dataset.params;
      params = JSON.parse(params);

      if (params.minimalDeposit.czk) {
        const minDep = params.minimalDeposit.czk.min;
        const maxDep = params.minimalDeposit.czk.max;

        if (typeof minDep === 'number')
          amounts.push(minDep)

        if (typeof maxDep === 'number')
          amounts.push(maxDep)
      }

      if (params.yield) {
        const minYield = params.yield.min;
        const maxYield = params.yield.max;

        if (typeof minYield === 'number')
          yields.push(minYield)

        if (typeof maxYield === 'number')
          yields.push(maxYield)
      }

      if (typeof params.timeHorizon === 'number')
        timeHorizon.push(params.timeHorizon)


      if (typeof params.paymentPeriod === 'number')
        paymentPeriod.push(params.paymentPeriod)
    });

    // set filter limits
    this.amount.limits = [Math.min(...amounts), Math.max(...amounts)];
    this.yield.limits = [Math.min(...yields), Math.max(...yields)];
    //console.log(this.yield.limits)
    // timeHorizon = [...new Set(timeHorizon)]; // retuns unique values
    // this.timeHorizon.limits = timeHorizon.sort((a, b) => a - b); // sort
    // this.timeHorizon.limits = timeHorizon ? [Math.min(...timeHorizon), Math.max(...timeHorizon)];

    paymentPeriod = [...new Set(paymentPeriod)]; // retuns unique values
    this.paymentPeriod.limits = paymentPeriod.sort((a, b) => a - b); // sort

    // parse url
    const thisPage = new URL(window.location.href);
    const urlParams = thisPage.searchParams;

    if (urlParams.has('deposit')) {
      const depositParams = urlParams.get('deposit');
      this.amountValues = depositParams.split('-')
          .map(item => parseInt(item));
      this.filterApplied = true;
    } else {
      this.amountValues = this.amount.limits;
    }
    if (urlParams.has('yield')) {
      const yieldParams = urlParams.get('yield');
      this.yieldValues = yieldParams.split('-')
          .map(item => parseInt(item));
      this.filterApplied = true;
    } else {
      this.yieldValues = this.yield.limits;
    }

    if (urlParams.has('time-horizon')) {
      const timeHorizonParams = urlParams.get('time-horizon');
      this.timeHorizon.values = timeHorizonParams.split('-')
          .map(item => parseInt(item));
      this.filterApplied = true;
    } else {
      this.timeHorizon.values = [Math.min(...this.timeHorizon.limits), Math.max(...this.timeHorizon.limits)];
    }

    if (urlParams.has('payment-period')) {
      const paymentPeriodParams = urlParams.get('payment-period');
      this.paymentPeriod.values = paymentPeriodParams.split('-')
          .map(item => parseInt(item));
      this.filterApplied = true;
    } else {
      this.paymentPeriod.values = this.paymentPeriod.limits;
    }

    if (urlParams.has('q')){
    this.search =  urlParams.get('q') ;
    this.filterApplied = true;
    }
    if ( urlParams.has('approved-cnb')){
    this.isApprovedByCnb = urlParams.get('approved-cnb') === "true" ;
    this.filterApplied = true;
  }
    if (urlParams.has('early-payment')){
    this.earlyRepaymentPossible =  urlParams.get('early-payment') === "true";
    this.filterApplied = true;
}
    if (urlParams.has('collaterals')){
    this.collaterals =  parseInt(urlParams.get('collaterals'));
    this.filterApplied = true;
}
    this.applyFilter();
    this.sortOffers();
  },
  watch: {
    filterApplied(newValue) {
      const resetBtn = document.querySelector('.offer-filter_reset');
      if (resetBtn) {
        if (newValue) {
          resetBtn.classList.remove('disabled');
        } else {
          resetBtn.classList.add('disabled');
        }
      }
    },
    // Sleduj všechny proměnné, které mohou ovlivnit stav filtru
    amountValueMin: 'updateFilterState',
    amountValueMax: 'updateFilterState',
    yieldValueMin: 'updateFilterState',
    yieldValueMax: 'updateFilterState',
    'paymentPeriod.values': 'updateFilterState',
    'timeHorizon.values': 'updateFilterState',
    search: 'updateFilterState',
    collaterals: 'updateFilterState',
    earlyRepaymentPossible: 'updateFilterState',
    isApprovedByCnb: 'updateFilterState'
  },
  methods: {
    changeFiler: function () {
      const thisPage = new URL(window.location.href);
      const urlParams = thisPage.searchParams;

      this.search ? urlParams.set('q', this.search) : urlParams.delete('q');
      this.isApprovedByCnb ? urlParams.set('approved-cnb', this.isApprovedByCnb) : urlParams.delete('approved-cnb');
      this.earlyRepaymentPossible ? urlParams.set('early-payment', this.earlyRepaymentPossible) : urlParams.delete('early-payment');

      this.filterApplied = false;

      if (JSON.stringify(this.amount.limits) !== JSON.stringify(this.amountValues)) {
        urlParams.set('deposit', this.amountValues.join('-'));
        this.filterApplied = true;
      } else {
        urlParams.delete('deposit')
      }

      if (JSON.stringify(this.yield.limits) !== JSON.stringify(this.yieldValues)) {
        urlParams.set('yield', this.yieldValues.join('-'))
        this.filterApplied = true;
      } else {
        urlParams.delete('yield')
      }

      if (this.paymentPeriod.values.length &&
          JSON.stringify(this.paymentPeriod.limits) !== JSON.stringify(this.paymentPeriod.values)) {
        this.paymentPeriod.values = this.paymentPeriod.values.sort((a, b) => a - b);
        urlParams.set('payment-period', this.paymentPeriod.values.join('-'))
        this.filterApplied = true;
      } else {
        urlParams.delete('payment-period')
      }

      if (this.timeHorizon.values.length &&
          JSON.stringify(this.timeHorizon.limits) !== JSON.stringify(this.timeHorizon.values)) {
        //this.timeHorizon.values = this.timeHorizon.values.sort((a, b) => a - b);
        urlParams.set('time-horizon', this.timeHorizon.values.join('-'))
        this.filterApplied = true;
      } else {
        urlParams.delete('time-horizon')
      }

      if(this.collaterals){
        urlParams.set('collaterals', this.collaterals)
        this.filterApplied = true;
      }else{
        urlParams.delete('collaterals');
      }

      window.history.pushState({}, '', thisPage);
      this.applyFilter();
    },
    applyFilter() {
      const activeOffers = document.getElementById('offers-active');
      const self = this;
      let i = 0;

      const amountActive = JSON.stringify(self.amountValues) !== JSON.stringify(self.amount.limits);
      const yieldActive = JSON.stringify(self.yieldValues) !== JSON.stringify(self.yield.limits);
      const timeHorizonActive = JSON.stringify(self.timeHorizon.values) !== JSON.stringify(self.timeHorizon.limits);
      const paymentPeriodActive = JSON.stringify(self.paymentPeriod.values) !== JSON.stringify(self.paymentPeriod.limits);
      const searchTerm = this.search ? this.search.toLowerCase() : '';

      Array.from(activeOffers.children).forEach(function (item) {
        let params = item.dataset.params;
        params = JSON.parse(params);
        let show = true;

        if (searchTerm && !(params.name.toLowerCase().includes(searchTerm)))
          show = false;

        if (self.isApprovedByCnb && self.isApprovedByCnb !== params.isApprovedByCnb)
          show = false;

        if (self.earlyRepaymentPossible && self.earlyRepaymentPossible !== params.earlyRepaymentPossible)
          show = false;

        if (amountActive && params.minimalDeposit.czk) {
          const minDep = params.minimalDeposit.czk.min;
          const maxDep = params.minimalDeposit.czk.max;
          if (maxDep) {
            if (!(maxDep >= self.amountValueMin && minDep <= self.amountValueMax))
              show = false;
          } else {
            if (!(minDep >= self.amountValueMin && minDep <= self.amountValueMax))
              show = false;
          }
        }

        if (yieldActive && params.yield) {
          const minYield = params.yield.min;
          const maxYield = params.yield.max;
          if (maxYield) {
            if (!(maxYield >= self.yieldValueMin && minYield <= self.yieldValueMax))
              show = false;
          } else {
            if (!(minYield >= self.yieldValueMin && minYield <= self.yieldValueMax))
              show = false;
          }
        }

        if (self.collaterals && self.collaterals > params.collaterals)
          show = false;

        if (paymentPeriodActive && !self.paymentPeriod.values.includes(params.paymentPeriod))
          show = false;

        function roundToQuarter(number) {
          return Math.round(number * 4) / 4;
        }

        const minTimeHorizon = roundToQuarter(params.timeHorizon.min / 12);
        const maxTimeHorizon = roundToQuarter(params.timeHorizon.max / 12);
        /*function customRound(number) { // upraveno tak, aby např 1.5 roku bylo zaokrouhleno
          let integerPart = Math.floor(number);
          let decimalPart = number - integerPart;

          if (decimalPart > 0.5) {
            return Math.ceil(number);
          } else if (decimalPart < 0.4) {
            return Math.floor(number);
          } else {
            return integerPart;
          }
        }*/
        //console.log([minTimeHorizon /12,Math.round(minTimeHorizon /12) ,roundToQuarter(minTimeHorizon /12) ]);
        const minVal = Math.min(...self.timeHorizon.values);
        const maxVal = Math.max(...self.timeHorizon.values);
        //console.log(self.timeHorizon.values);
        //console.log([minVal,maxVal]);
        if (maxTimeHorizon) {
          if (timeHorizonActive && !(maxTimeHorizon >= minVal && minTimeHorizon <= maxVal))
            show = false;
        } else {
          if (timeHorizonActive && !(minTimeHorizon >= minVal && minTimeHorizon <= maxVal))
            show = false;
        }

        if (show) {
          item.style.display = 'block';
          i++;
        } else {
          item.style.display = 'none';
        }
      })
      document.getElementById('offer-filter_items-count').innerHTML = i;
    },
    changeOrder() {
      const thisPage = new URL(window.location.href);
      if (this.order && this.order !== 'none') {
        thisPage.searchParams.set('order', this.order);
      } else {
        thisPage.searchParams.delete('order');
      }
      window.history.pushState({}, '', thisPage);

      this.sortOffers();
    },
    sortOffers() {
      const activeOffers = document.getElementById('offers-active');
      if (!activeOffers) {
        console.log("Active offers container not found.");
        return;
      }
      let order = false;
      const thisPage = new URL(window.location.href);
      if (thisPage.searchParams.has('order')) {
        order = thisPage.searchParams.get('order');
        this.order = order;
      }

      const offerArray = Array.from(activeOffers.children);
      let resetOrder = false;
      switch (order) {
        case 'az':
          this.sortByParam(offerArray, 'name');
          break;
        case 'za':
          this.sortByParam(offerArray, 'name');
          offerArray.reverse();
          break;
        case 'yield-asc':
          this.sortByParam(offerArray, 'yield');
          break;
        case 'yield-desc':
          this.sortByParam(offerArray, 'yield', true);
          offerArray.reverse();
          break;
        case 'deposit-asc':
          this.sortByParam(offerArray, 'minimalDeposit', false, 'czk');
          break;
        case 'deposit-desc':
          this.sortByParam(offerArray, 'minimalDeposit', false, 'czk');
          offerArray.reverse();
          break;
        default:
          let resetOrder = true;
          // console.log(`Sorry, unsupported order: ${this.order}`);
      }
      // Clear the current content of activeOffers
      //activeOffers.innerHTML = '';
      // Append the sorted elements back to activeOffers
      offerArray.forEach(function (offer, idx) {
        if (resetOrder) {
          offer.style.removeProperty("order");
        } else {
          offer.style.order = idx + 1;
        }
        let cssClass = offer.getAttribute('data-scroll-animation');
        cssClass = cssClass.split(' '); // to Array
        if (!offer.classList.contains(...cssClass))
          offer.classList.add(...cssClass);
      });
    },
    sortByParam(array, paramName, fromMaxIfExists = false, currency = false) {
      array.sort(function (a, b) {
        let paramsA = JSON.parse(a.dataset.params);
        let paramsB = JSON.parse(b.dataset.params);

        if (paramName === 'name') {
          return paramsA[paramName].localeCompare(paramsB[paramName]);
        } else {

          let paramA = paramsA[paramName];
          let paramB = paramsB[paramName];
          if (currency) {
            paramA = paramA[currency];
            paramB = paramB[currency];
          }
          console.log(paramA);
          console.log(paramB);

          if (fromMaxIfExists) {
            paramA = paramA.max ?? paramA.min;
            paramB = paramB.max ?? paramB.min;
            return paramA - paramB;
          } else {
            let valueA = paramA && paramA.min !== undefined ? paramA.min : 0;
            let valueB = paramB && paramB.min !== undefined ? paramB.min : 0;
            return valueA - valueB;
          }
        }
      });
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.changeFiler();
      }, 500);
    },
    handleCheckboxMouseover(hoveredIdx, maxValue) {
      // Metoda se spustí při najetí myší na checkbox
      this.highlightCheckbox(hoveredIdx, maxValue);
    },
    handleCheckboxMouseleave(maxValue) {
      this.highlightCheckbox(this.collaterals - 1, maxValue);
    },
    handleCheckboxChange(idx) {
      if (Math.min(...this.collateralsChecked) === idx) {
        this.collaterals = idx;
        if (idx === 0) { // když nastavíš 0
          this.collateralsChecked = true;
          this.collaterals = false;
        }
      } else { // když odznačíš
        this.collateralsChecked = [];
        this.collaterals = false;
      }
    },
    highlightCheckbox(hoveredIdx, maxValue) {
      this.collateralsChecked = Array.from({length: maxValue - hoveredIdx - 1}, (_, idx) => maxValue - idx - 1);
    },
    filterAmount(values) {
      if (Array.isArray(values)) {
        return values.map(item =>
                item.toLocaleString('cs-CZ') + 'Kč'
            //  item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0") + 'Kč'
        );
      } else {
        return values.toLocaleString('cs-CZ') + 'Kč'
      }
    },
    updateVariable(value, variable) {
      const number = parseFloat(value.replace(/\D/g, ''));
      if (!isNaN(number)) {
        this[variable] = number;
        //eval(`this.${variable} = ${number}`);
        //eval(`console.log(this.${variable})`);
      }
    },
    filterYield(values) {
      if (Array.isArray(values)) {
        return values.map(item =>
            item.toString() + ' %'
        );
      } else {
        return values.toString() + ' %'
      }
    },
    filterPaymentPeriod(value) {
      switch (value) {
        case 1:
          return 'Měsíčně'
        case 3:
          return 'Čtvrtletně'
        case 6:
          return 'Pololetně'
        case 12:
          return 'Ročně'
        default:
          return 'Každé ' + value + ' měsíce';
      }
    },
    resetFilter() {
      this.amountValueMin = this.amount.limits[0];
      this.amountValueMax = this.amount.limits[1];
      this.yieldValueMin = this.yield.limits[0];
      this.yieldValueMax = this.yield.limits[1];
      this.paymentPeriod.values = this.paymentPeriod.limits;
      this.timeHorizon.values = this.timeHorizon.limits;
      this.search = '';
      this.collaterals = false;
      this.collateralsChecked = [];
      this.earlyRepaymentPossible = false;
      this.isApprovedByCnb = false;
      this.order = 'none';

      // Clear URL parameters
      const thisPage = new URL(window.location.href);
      const urlParams = thisPage.searchParams;
      urlParams.delete('deposit');
      urlParams.delete('yield');
      urlParams.delete('time-horizon');
      urlParams.delete('payment-period');
      urlParams.delete('q');
      urlParams.delete('approved-cnb');
      urlParams.delete('early-payment');
      urlParams.delete('collaterals');
      urlParams.delete('order');
      window.history.pushState({}, '', thisPage);

      this.applyFilter();
      this.sortOffers();
      this.filterApplied = false;
    }
  },
  computed: {
    amountValues: {
      get() {
        return [this.amountValueMin, this.amountValueMax];
      },
      set(newValue) {
        this.amountValueMin = Math.min(...newValue);
        this.amountValueMax = Math.max(...newValue);
      }
    },
    yieldValues: {
      get() {
        return [this.yieldValueMin, this.yieldValueMax];
      },
      set(newValue) {
        this.yieldValueMin = Math.min(...newValue);
        this.yieldValueMax = Math.max(...newValue);
      }
    }
  },
}
</script>

<style scoped>
</style>